export const generateChangedText = (type, months, previous) => {
  const fromText = previous ? ` from ${previous} ` : ' ';
  const monthOrMonths = months > 0 ? 'months' : 'month';
  const monthCount = months > 0 ? `${months} ` : '';

  return `Changed ${type}${fromText}within the last ${monthCount}${monthOrMonths}`;
};
